var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBobaNetworkLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st1{fill:#CCFF00;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#1CD7D2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2806320627344"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 2500,
    height: 2500
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1267,2146c-147,0-280-60-377-156c-96-96-156-230-156-377c0-114,36-219,97-306l35,209c-7,31-11,64-11,97     c0,114,46,217,121,291c75,75,178,121,291,121c114,0,217-46,291-121c75-75,121-178,121-291c0-114-46-217-121-291     c-75-75-178-121-291-121c-109,0-208,42-281,111l-23-136c86-60,191-95,304-95c147,0,280,60,377,156c96,96,156,230,156,377     s-60,280-156,377c-96,96-230,156-377,156V2146z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1105,
    cy: 1456,
    r: 71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1287,
    cy: 1614,
    r: 71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1336,
    cy: 1374,
    r: 71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1508,
    cy: 1537,
    r: 71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1058,
    cy: 1690,
    r: 71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1462,
    cy: 1769,
    r: 71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1236,
    cy: 1856,
    r: 71
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M993,1566c9-12,13-27,10-43L814,402c-3-16-11-29-23-37c-12-9-27-13-43-10s-29,11-37,23c-9,12-13,27-10,43     l189,1121c3,16,11,29,23,37c12,9,27,13,43,10S985,1578,993,1566z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBobaNetworkLogo);
export default __webpack_public_path__ + "static/media/boba-network-logo.5aede2341cff5e6bb90ee93e25514d4a.svg";
export { ForwardRef as ReactComponent };